import apiKeyService from 'api/apiKey';

function Ctrl($scope, loggerService, $q) {
  $scope.loading = true;

  $q.resolve(apiKeyService.listByAffiliateId($scope.affiliate.id))
    .then(response => {
      $scope.loading = false;

      $scope.apiKeys = response;
    })
    .catch(response => {
      $scope.loading = false;

      loggerService.error(response);
    });
}

Ctrl.$inject = [
  '$scope',
  'loggerService',
  '$q'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/developers/developersCtrl.js